export default {
  thanks: '/thanks',
  mobileThanks: '/mobile/thanks',
  switch: '/switch',
};
